<template>
  <v-container fluid>
    <TopHeader>
      <template v-slot:title>
        <span class="text-h5">
          Manage /
          <span class="breadcrumb-link" @click="returnToBrands">Brands</span>
          /
          <span class="primary--text">New brand</span>
        </span>
      </template>
      <template v-slot:right>
        <span
          class="subtitle-1 grey--text font-weight-light d-flex"
          style="align-items: flex-end"
        >
          <v-btn
            @click="submit()"
            color="primary"
            :disabled="!hasChanged || isLoading || !isFormValid"
            :loading="isLoading"
          >
            <template>
              <v-icon left>mdi-alert-circle-check-outline</v-icon>
              Create brand
            </template>
          </v-btn>
        </span>
      </template>
    </TopHeader>
    <v-row class="mt-5">
      <v-col cols="12">
        <div class="text-center primary--text text-h6">Current</div>
        <Brand
          @onLangTabChange="t => (langTab = t)"
          :lang-tab-index="langTab"
          v-model="brand"
          @isFormValid="updateIsFormValid"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Brand } from "@/components"
import { BrandService } from "@/services"
import TopHeader from "@/components/base/TopHeader.vue"
import { PROPOSAL_STATUS } from "@/data"
import _ from "lodash"

export default {
  components: {
    TopHeader,
    Brand
  },
  data() {
    return {
      isFormValid: null,
      langTab: null,
      isLoading: false,
      proposal: null,
      brand: {
        id: null,
        status: null,
        approved: null,
        updated_at: null,
        created_at: null,
        verified_at: null,
        verified_attached_message: null,
        data: {
          locales: [
            {
              code: "en",
              name: "English",
              data: {
                name: "",
                description: ""
              }
            }
          ],
          image: null
        }
      },
      emptyBrand: null
    }
  },
  created() {
    this.brandEmpty = this.lo.cloneDeep(this.brand)
  },
  computed: {
    hasChanged() {
      if (this.brand == null) {
        return false
      }
      return !this.lo.isEqual(this.brandEmpty, this.brand)
    }
  },
  watch: {},
  methods: {
    updateIsFormValid(value) {
      this.isFormValid = value
    },
    returnToBrands() {
      if (this.$store.state.globalBrand) {
        // Need to refresh brand list
        this.isLoading = true
        BrandService.list(this).then(r => {
          //this.$store.commit("setBrands", r.results)
          this.$store.commit("setGlobalBrand", r.results).finally(() => {
            this.isLoading = false
          })
        })
      }
      //this.$store.commit("setGlobalBrand", { id: null, name: "All brands" })
      this.$router.push({ name: "Brand" })
    },
    handleAddLocale(locale) {
      this.brand?.data?.locales?.push(locale)
    },
    createBrand() {
      return new Promise((resolve, reject) => {
        let approveState = {
          approved: this.$store.getters.isUserAdmin,
          verified_by_id: this.$store.state.user?.id || null,
          verified_at: this.$store.getters.isUserAdmin ? new Date() : null,
          data_old: null,
          data_approved: this.$store.getters.isUserAdmin
            ? this.brand.data
            : null
        }
        BrandService.create(this, {
          // brand_id: null,
          data_approved: this.brand.data,
          data: this.brand.data,
          status: PROPOSAL_STATUS.CREATE_REQUEST
          // ...approveState
        })
          .then(r => {
            resolve(r)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {})
      })
    },
    async submit() {
      await this.$nextTick()
      if (
        confirm(
          `Are you sure you want to create this brand? ${
            this.$store.getters.isUserAdmin
              ? "(As an admin, this request is approved automatically)"
              : ""
          }`
        )
      ) {
        this.isLoading = true
        this.createBrand()
          .then(() => {
            this.$store.commit("success", "Brand created successfully")
            this.returnToBrands()
          })
          .catch(() => {
            this.$store.commit(
              "warning",
              "Something went wrong, please try again later"
            )
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
